import React from 'react'
import { useSelector } from 'react-redux'
import ChangePassword from '../../components/ChangePassword/ChangePassword';

import './changepass.scss';
import apiUrl from '../../libs/baseUrl';

function ChangePass() {

  const authMe = useSelector(state => state.authme.data);

  return (
    <div className='changePass'>

     <div className='changePass_container'>
             <ChangePassword empInfo={authMe} url={`${apiUrl}/auth/password/change`} methodType="post" isChangerIsUser={true}/>
     </div>

    </div>
  )
}

export default ChangePass;